module.exports = __webpack_public_path__ + "static/iso14001-c3d15c4b33e27ea114e369cb7d5f6c77.svg";